# Capacitor Camera plugin - only included when building for capacitor target
import ["Camera", "CameraResultType", "CameraSource"], from: "@capacitor/camera" # Pragma: capacitor

class CameraController < Stimulus::Controller
  def takePhoto
    if defined?(Camera)
      # Native mobile - use Capacitor Camera plugin
      takePhotoCapacitor()
    else
      # Browser - use getUserMedia
      takePhotoBrowser()
    end
  end

  def takePhotoCapacitor
    # Camera is guaranteed to exist when building for capacitor target
    result = await Camera.getPhoto(
      quality: 80,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      source: CameraSource.Camera
    )
    handlePhoto(result.base64String)
  end

  def takePhotoBrowser
    # Start video stream from webcam
    stream = await navigator.mediaDevices.getUserMedia(video: { facingMode: "user" })
    videoTarget.srcObject = stream
    videoTarget.classList.remove("hidden")
    captureBtnTarget.classList.remove("hidden")
    formTarget.classList.add("hidden")
  end

  def capture
    # Capture frame from video to canvas
    canvas = document.createElement("canvas")
    canvas.width = videoTarget.videoWidth
    canvas.height = videoTarget.videoHeight
    canvas.getContext("2d").drawImage(videoTarget, 0, 0)

    # Stop video stream
    videoTarget.srcObject.getTracks().each { |track| track.stop() }
    videoTarget.classList.add("hidden")
    captureBtnTarget.classList.add("hidden")

    # Get base64 image data (without data URL prefix)
    dataUrl = canvas.toDataURL("image/jpeg", 0.8)
    base64 = dataUrl.sub("data:image/jpeg;base64,", "")

    # Show preview and form
    handlePhoto(base64)
  end

  def chooseFromGallery
    if defined?(Camera)
      # Native mobile - use Capacitor Camera with Photos source
      chooseFromGalleryCapacitor()
    else
      # Browser - use file input
      chooseFromGalleryBrowser()
    end
  end

  def chooseFromGalleryCapacitor
    result = await Camera.getPhoto(
      quality: 80,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      source: CameraSource.Photos
    )
    handlePhoto(result.base64String)
  end

  def chooseFromGalleryBrowser
    input = document.createElement("input")
    input.type = "file"
    input.accept = "image/*"
    input.onchange = -> { handleFileSelect(input) }
    input.click()
  end

  def handleFileSelect(input)
    file = input.files[0]
    return unless file

    reader = FileReader.new
    reader.onload = -> {
      base64 = reader.result.sub(/^data:image\/\w+;base64,/, "")
      handlePhoto(base64)
    }
    reader.readAsDataURL(file)
  end

  def handlePhoto(base64)
    imageDataTarget.value = base64
    previewTarget.src = "data:image/jpeg;base64,#{base64}"
    formTarget.classList.remove("hidden")
    captionInputTarget.focus()
  end

  def reset
    # Reset form after successful save
    imageDataTarget.value = ""
    previewTarget.src = ""
    captionInputTarget.value = ""
    formTarget.classList.add("hidden")
  end
end
